import React, {useState} from 'react'
// import Testing from '../../pages/Testing'
import VideoDescription from './VideoDescription'
import SectionTabButtons from './SectionTabButtons'
import PlaylistSidebar from './PlaylistSidebar'

const BottomPlayerTabs = ({contributor, description, course, fullAccess, title}) => {

    const [sectionTab, setSectionTab] = useState('LessonInfo');

    return (
        <div className="d-block d-lg-none">
            <SectionTabButtons sectionTab={sectionTab} setSectionTab={setSectionTab} />
            
            {sectionTab === 'LessonInfo' && (
                <VideoDescription contributor={contributor} description={description} title={title} />
            )}

            {sectionTab === 'CourseOverview' && (
                <PlaylistSidebar course={course} fullAccess={fullAccess} />
            )}
        </div>
    )
}

export default BottomPlayerTabs;